<template>
  <div class="button-navi-holder">
    <div class="page-logo-navi">
      <router-link to="/"
        ><WpImage :data="logoTopDark" class="logo-image logo-dark" />
      </router-link>
    </div>
    <span class="spacer" />
    <div v-if="extraLink" class="extra-link">
      <AcfLink :data="extraLink" />
    </div>
    <div @click="openMenu" class="burger-holder">
      <div class="text">{{ naviText }}</div>
      <div
        :class="[{ closed: !isOpenNav }, { open: isOpenNav }]"
        class="hamburger"
      >
        <div class="burger-main">
          <div class="burger-inner">
            <span class="top"></span>
            <span class="mid"></span>
            <span class="bot"></span>
          </div>
        </div>

        <div class="svg-main">
          <svg class="svg-circle">
            <path
              class="path"
              fill="none"
              stroke="#2C2926"
              stroke-miterlimit="10"
              stroke-width="4"
              d="M 34 2 C 16.3 2 2 16.3 2 34 s 14.3 32 32 32 s 32 -14.3 32 -32 S 51.7 2 34 2"
            />
          </svg>
        </div>
        <div class="path-burger">
          <div class="animate-path">
            <div class="path-rotation"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WpImage from "@/components/elements/WpImage";
import AcfLink from "@/components/elements/AcfLink";

import { setCookie, getCookie } from "@/plugins/helpers";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "navi-button",
  data() {
    return {
      naviOpen: true,
      logoTopDark: WPVUE.options.page_logo,
      extraLink: WPVUE.options.extra_menu_button
    };
  },
  computed: {
    //fromTop() {},
    ...mapGetters(["isOpenNav", "logoVisible"]),
    naviText() {
      let text = "";
      if (this.isOpenNav) {
        text = "Skjul";
      } else {
        text = "Meny";
      }
      return text;
    }
  },
  beforeMount() {
    this.setHeaderStatus(this.checkCookie("openMenu", "true"));
  },
  components: {
    WpImage,
    AcfLink
  },
  watch: {
    isOpenNav(val) {
      this.acceptCookie(val);
    },
    $route(to, from) {
      if (
        to &&
        from &&
        to.path !== from.path &&
        this.isOpenNav &&
        $(window).width() < 1160
      ) {
        this.openMenu();
      }
    }
  },
  methods: {
    ...mapMutations({
      setHeaderStatus: "SET_NAVIGATION_STATUS",
      userActionOpen: "SET_USER_CHANGE_NAVI"
    }),
    checkOpenNav() {
      this.setHeaderStatus(this.naviOpen);
    },
    openMenu() {
      const action = !this.isOpenNav;
      this.setHeaderStatus(action);
      this.userActionOpen(action);
      $(window).trigger("resize");
    },
    acceptCookie(val) {
      setCookie("openMenu", val, 60);
      this.isAccepted = true;
    },
    checkCookie(cookieName, value) {
      var cookie = getCookie(cookieName);
      if (cookie !== value) {
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>

<style lang="scss">
@import "./../../assets/scss/mixins.scss";
@import "./../../assets/scss/vars.scss";
.button-navi-holder {
  position: relative;
  display: flex;
  .extra-link{
    margin-right: 50px;
    @include mquery(767px) {
      margin-right: 25px;
    }

    a{
      color: $fontColor;
      text-decoration: none;
      &:hover{
        border-bottom: 2px solid $purple;
      }
    }
  }
  .spacer{
    flex: 1;
  }
  .logo-image {
    padding: 0;
    margin: 0;
    position: absolute;
    left: 5px;
    top: -5px;
    img {
      height: 32px;
    }
    @include mquery(767px) {
      left: 11px;
      img {
        height: 28px;
      }
    }
    @include mquery(499px) {
      left: -4px;
      top: -3px;
      img {
        height: 28px;
      }
    }
  }
  .burger-holder {
    cursor: pointer;
    display: flex;
    height: 22px;
    justify-content: flex-end;
    //transform: translate(32px,5px);
    .text {
      @include mquery(499px) {
        margin-right: -37px;
      }
    }
  }
  .closed .svg-main .path {
    //stroke: $fontColor;
  }
  .svg-main .path {
    stroke: #fff;
    //transition: stroke 0.2s ease-in-out;
    //transition-delay: 0.2s;
  }
  .burger-holder {
    //width: 100%;
  }
  .hamburger {
    transform: scale(0.7);
    position: relative;
    display: block;
    width: 68px;
    height: 68px;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    right: 10px;
    top: -24px;
    transition: 0.15s ease-in-out;
    &.open {
      //transform: scale(0.5);
    }
    @include mquery(499px) {
      right: -27px;
    }
  }

  .burger-main {
    position: absolute;
    padding: 20px 16px;
    height: 68px;
    width: 68px;
  }

  .burger-inner {
    position: relative;
    height: 28px;
    width: 36px;
  }

  .burger-main span {
    position: absolute;
    display: block;
    height: 4px;
    width: 36px;
    border-radius: 2px;
    background: #2c2926;
    transition: background 0.2s ease-in-out;
  }

  .top {
    top: 0;
    transform-origin: 34px 2px;
  }

  .bot {
    bottom: 0;
    transform-origin: 34px 2px;
  }

  .mid {
    top: 12px;
  }

  .svg-main {
    position: absolute;
    top: 0;
    left: 0;
    width: 68px;
    height: 68px;
  }

  .circle {
    width: 68px;
    height: 68px;
  }

  .path {
    stroke-dasharray: 240;
    stroke-dashoffset: 240;
    stroke-linejoin: round;
  }

  .hamburger.open .path {
    animation: dash-in 0.6s linear normal;
    animation-fill-mode: forwards;
  }

  .hamburger.closed .path {
    animation: dash-out 0.6s linear normal;
    animation-fill-mode: forwards;
  }

  .hamburger.open .top {
    animation: close-top-out 0.6s linear normal;
    animation-fill-mode: forwards;
  }

  .hamburger.open .bot {
    animation: close-bot-out 0.6s linear normal;
    animation-fill-mode: forwards;
  }

  .hamburger.closed .top {
    animation: close-top-in 0.6s linear normal;
    animation-fill-mode: forwards;
  }

  .hamburger.closed .bot {
    animation: close-bot-in 0.6s linear normal;
    animation-fill-mode: forwards;
  }

  .hamburger.open .mid {
    animation: burger-fill-out 0.6s linear normal;
    animation-fill-mode: forwards;
  }

  .hamburger.closed .mid {
    animation: burger-fill-in 0.6s linear normal;
  }

  .path-burger {
    position: absolute;
    top: 0;
    left: 0;
    height: 68px;
    width: 68px;
    -webkit-mask: url(#mask);
    mask: url(#mask);
    -webkit-mask-box-image: url("//dev.awsm.in/codepen/mask.svg");
  }

  .animate-path {
    position: absolute;
    top: 0;
    left: 0;
    width: 68px;
    height: 68px;
  }

  .path-rotation {
    height: 34px;
    width: 34px;
    margin: 34px 34px 0 0;
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transform-origin: 100% 0;
    transform-origin: 100% 0;
  }

  .path-rotation:before {
    content: "";
    display: block;
    width: 30px;
    height: 34px;
    margin: 0 4px 0 0;
    background: #2c2926;
    transition: background 0.2s ease-in-out;
  }

  .hamburger.open .animate-path {
    animation: circle-in 0.6s linear normal;
    animation-fill-mode: forwards;
  }

  .hamburger.closed .animate-path {
    animation: circle-out 0.6s linear normal;
    animation-fill-mode: forwards;
  }

  @-webkit-keyframes dash-in {
    0% {
      stroke-dashoffset: 240;
    }

    40% {
      stroke-dashoffset: 240;
    }

    100% {
      stroke-dashoffset: 0;
    }
  }

  @keyframes dash-in {
    0% {
      stroke-dashoffset: 240;
    }

    40% {
      stroke-dashoffset: 240;
    }

    100% {
      stroke-dashoffset: 0;
    }
  }

  @-webkit-keyframes dash-out {
    0% {
      stroke-dashoffset: 0;
    }

    40% {
      stroke-dashoffset: 240;
    }

    100% {
      stroke-dashoffset: 240;
    }
  }

  @keyframes dash-out {
    0% {
      stroke-dashoffset: 0;
    }

    40% {
      stroke-dashoffset: 240;
    }

    100% {
      stroke-dashoffset: 240;
    }
  }

  @keyframes close-top-out {
    0% {
      left: 0;
      top: 0;
      transform: rotate(0deg);
    }

    20% {
      left: 0;
      top: 0;
      transform: rotate(15deg);
    }

    80% {
      left: -5px;
      top: 0;
      transform: rotate(-60deg);
    }

    100% {
      left: -5px;
      top: 1px;
      transform: rotate(-45deg);
    }
  }

  @keyframes close-bot-out {
    0% {
      left: 0;
      transform: rotate(0deg);
    }

    20% {
      left: 0;
      transform: rotate(-15deg);
    }

    80% {
      left: -5px;
      transform: rotate(60deg);
    }

    100% {
      left: -5px;
      transform: rotate(45deg);
    }
  }

  @keyframes close-top-in {
    0% {
      left: -5px;
      bot: 0;
      transform: rotate(-45deg);
    }

    20% {
      left: -5px;
      bot: 0;
      transform: rotate(-60deg);
    }

    80% {
      left: 0;
      bot: 0;
      transform: rotate(15deg);
    }

    100% {
      left: 0;
      bot: 1px;
      transform: rotate(0deg);
    }
  }

  @keyframes close-bot-in {
    0% {
      left: -5px;
      transform: rotate(45deg);
    }

    20% {
      left: -5px;
      transform: rotate(60deg);
    }

    80% {
      left: 0;
      transform: rotate(-15deg);
    }

    100% {
      left: 0;
      transform: rotate(0deg);
    }
  }

  @keyframes burger-fill-in {
    0% {
      width: 0;
      left: 36px;
    }

    40% {
      width: 0;
      left: 40px;
    }

    80% {
      width: 36px;
      left: -6px;
    }

    100% {
      width: 36px;
      left: 0px;
    }
  }

  @keyframes burger-fill-out {
    0% {
      width: 36px;
      left: 0px;
    }

    20% {
      width: 42px;
      left: -6px;
    }

    40% {
      width: 0;
      left: 40px;
    }

    100% {
      width: 0;
      left: 36px;
    }
  }
  @keyframes circle-out {
    0% {
      transform: rotate(0deg);
    }

    40% {
      transform: rotate(180deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes circle-in {
    0% {
      transform: rotate(360deg);
    }

    40% {
      transform: rotate(180deg);
    }

    100% {
      transform: rotate(0deg);
    }
  }
}
</style>
